import React from "react";
import { createPortal } from "react-dom";

const Modal = ({
  children,
  onClose,
  maxWidth = "max-w-2xl",
  heightClass = "h-[90vh] max-h-[90vh]",
  noPadding = false,
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div
        className={`flex w-full flex-col overflow-hidden rounded-lg bg-theme-main ${maxWidth} ${heightClass} ${
          noPadding ? "p-0" : "p-6"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
